
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherPhenom } from './GenWeatherPhenom';

export class GenWeatherPhenomGroup {

    id: number;
    description: string;
    displayName: string;
    ordering: number;
    phenoms: GenWeatherPhenom[];

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherPhenomGroup: GenWeatherPhenomGroup);
    constructor( id: number );

    constructor( input?: GenWeatherPhenomGroup|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.description = input.description; // string [string]
            this.displayName = input.displayName; // string [string]
            this.ordering = input.ordering; // int [number]
            if ( input.phenoms && input.phenoms.map ) { // list [GenWeatherPhenom]
                this.phenoms = input.phenoms.map( ( x: GenWeatherPhenom ) => {
                    return new GenWeatherPhenom( x );
                } );
            } else {
                this.phenoms = input.phenoms;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherPhenomGroup[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherPhenomGroup(a));
        } else {
          return [];
        }
    }
}

